<template>
  <div
    class="
      bg-primary
      z-[3]
      transition-all
      main-menu
      md:px-[3vw]
      grid grid-cols-12
      pt-[100px]
      pb-[0px]
      md:pb-[15vh] md:pt-[15vh] md:place-content-center
    "
    :class="{ 'menu-opened': menuOpened }"
  >
    <div class="col-span-4 flex-col items-center lg:flex hidden">
      <img
        src="/static/images/logo.png"
        alt="menu-logo"
        class="h-[200px] w-[200px]"
      />
      <div
        class="text-2xl font-bold mt-2 al-bold"
        style="font-weight: bold !important"
      >
        {{ content.ismailKhayat }}
      </div>
      <div class="text-xl font-bold mt-2">{{ content.artGallery }}</div>
    </div>
    <div
      class="
        lg:col-span-8
        hidden
        place-content-center
        col-span-12
        md:grid
        grid-cols-12
      "
    >
      <div class="col-span-3">
        <div class="font-bold mb-8">{{ content.about }}</div>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/biography"
        >
          <div class="mb-2">{{ content.biography }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/personalphotos"
        >
          <div class="mb-2">{{ content.photoGallery }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/contact"
        >
          <div class="mb-2">{{ content.contactUs }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
      </div>
      <div class="col-span-3">
        <div class="font-bold mb-8">{{ content.artWorks }}</div>

        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/works?type=collections"
        >
          <div class="mb-2">{{ content.collections }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/works?type=paintings"
        >
          <div class="mb-2">{{ content.paintings }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/works?type=drawings"
        >
          <div class="mb-2">{{ content.drawings }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/works?type=stones"
        >
          <div class="mb-2">{{ content.stones }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/works?type=unfinishedworks"
        >
          <div class="mb-2">{{ content.unfinishedworks }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
      </div>
      <div class="col-span-3">
        <div class="font-bold mb-8">{{ content.mediaAndArchive }}</div>

        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/archive?type=books"
        >
          <div class="mb-2">{{ content.books }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/archive?type=writings"
        >
          <div class="mb-2">{{ content.writings }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/videos"
        >
          <div class="mb-2">{{ content.videos }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
      </div>
      <div class="col-span-3">
        <div class="font-bold mb-8">{{ content.legacy }}</div>

        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/legacy?type=internationalacclaims"
        >
          <div class="mb-2">
            {{ content.internationalacclaims }}
          </div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/legacy?type=exhibitions"
        >
          <div class="mb-2">{{ content.exhibitions }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/legacy?type=impactonart"
        >
          <div class="mb-2">{{ content.impactonart }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/legacy?type=achievements"
        >
          <div class="mb-2">{{ content.achievements }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
        <router-link
          class="group flex items-center"
          @click="menuOpened = false"
          to="/legacy?type=projects"
        >
          <div class="mb-2">{{ content.projects }}</div>
          <i
            class="
              fa fa-chevron-right
              opacity-0
              group-hover:opacity-100
              mb-2
              rtl:rotate-180
              text-xs
              rtl:group-hover:mr-2
              ltr:group-hover:ml-2
              transition-all
              duration-200
            "
          ></i>
        </router-link>
      </div>
    </div>
    <div class="block col-span-12 md:hidden overflow-y-auto">
      <MenuCollapse :title="content.about">
        <router-link @click="menuOpened = false" to="/biography">
          <div class="px-6 py-3">{{ content.biography }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/personalphotos">
          <div class="px-6 py-3">{{ content.photoGallery }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/contact">
          <div class="px-6 py-3">{{ content.contactUs }}</div>
        </router-link>
      </MenuCollapse>
      <MenuCollapse :title="content.artWorks">
        <!-- <router-link @click="menuOpened = false" to="/works?type=allArtWorks">
          <div class="px-6 py-3">{{ content.allArtWorks }}</div>
        </router-link> -->
        <router-link @click="menuOpened = false" to="/works?type=collections">
          <div class="px-6 py-3">{{ content.collections }}</div>
        </router-link>

        <router-link @click="menuOpened = false" to="/works?type=paintings">
          <div class="px-6 py-3">{{ content.paintings }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/works?type=drawings">
          <div class="px-6 py-3">{{ content.drawings }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/works?type=stones">
          <div class="px-6 py-3">{{ content.stones }}</div>
        </router-link>
        <router-link
          @click="menuOpened = false"
          to="/works?type=unfinishedworks"
        >
          <div class="px-6 py-3">
            {{ content.unfinishedworks }}
          </div>
        </router-link>
      </MenuCollapse>
      <MenuCollapse :title="content.mediaAndArchive">
        <router-link @click="menuOpened = false" to="/archive?type=books">
          <div class="px-6 py-3">{{ content.books }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/archive?type=writings">
          <div class="px-6 py-3">{{ content.writings }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/videos">
          <div class="px-6 py-3">{{ content.videos }}</div>
        </router-link>
      </MenuCollapse>
      <MenuCollapse :title="content.legacy">
        <router-link
          @click="menuOpened = false"
          to="/legacy?type=internationalacclaims"
        >
          <div class="px-6 py-3">
            {{ content.internationalacclaims }}
          </div>
        </router-link>
        <router-link @click="menuOpened = false" to="/legacy?type=exhibitions">
          <div class="px-6 py-3">{{ content.exhibitions }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/legacy?type=impactonart">
          <div class="px-6 py-3">{{ content.impactonart }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/legacy?type=achievements">
          <div class="px-6 py-3">{{ content.achievements }}</div>
        </router-link>
        <router-link @click="menuOpened = false" to="/legacy?type=projects">
          <div class="px-6 py-3">{{ content.projects }}</div>
        </router-link>
      </MenuCollapse>
    </div>
  <div class="absolute bottom-10 menu-copyright" >
      <div class="text-sm mt-2">
        {{ content.websiteBy }}
        <a href="https://blackace.tech" class="font-bold">Black Ace </a>
      </div>
    </div>
  </div>

  <div
    class="
      border-b
      header
      px-[3vw]
      top-0
      right-0
      w-full
      h-[100px]
      absolute
      z-[6]
      flex
      items-center
      justify-between
    "
    :style="`border-color: ${borderColor}`"
  >
    <router-link to="/" @click="menuOpened = false">
      <div
        class="flex items-center"
        :style="`color:${textColor}`"
        :class="{ 'lg:opacity-0': menuOpened }"
      >
        <img
          src="/static/images/logo.png"
          alt="logo"
          class="w-auto lg:h-[80px] h-[60px] transition-all duration-75"
        />
        <div class="ltr:ml-2 rtl:mr-2 md:block hidden">
          <div class="text-lg font-bold">{{ content.ismailKhayat }}</div>
          <div>{{ content.artGallery }}</div>
        </div>
      </div>
    </router-link>
    <div class="flex items-center cursor-pointer">
      <div class="relative">
        <div class="flex items-center py-2">
          <div
            class="flex items-center select-none"
            @click="languageOpened = !languageOpened"
            @mouseleave="languageOpened = false"
          >
            <div
              class="
                h-[24px]
                w-[132px]
                second-language
                flex
                items-center
                absolute
                transition-all
                duration-300
                ltr:left-[-54px]
                rtl:right-[-54px]
              "
              :class="languageOpened ? 'opacity-100' : 'opacity-0'"
              :style="`color:${textColor}`"
            >
              <div
                class="transition-all duration-300"
                :class="
                  languageOpened ? 'ltr:ml-0 rtl:mr-0' : 'ltr:ml-32 rtl:mr-32'
                "
                @click="updateLanguage"
              >
                {{ language == "en" ? "Kurdish" : "English" }}
              </div>
            </div>
            <div
              class="h-[24px] w-[1px] mx-2 transition-all duration-300"
              :style="`background:${borderColor}`"
              :class="languageOpened ? 'opacity-100' : 'opacity-0'"
            ></div>
            <div
              class="w-16"
              :style="`color:${textColor}`"
              @mouseover="languageOpened = true"
            >
              {{ language == "en" ? "English" : "کوردی" }}
            </div>
            <div
              class="
                w-[15px]
                h-[15px]
                rounded-full
                flex
                justify-center
                items-center
              "
            >
              <div
                class="
                  min-w-[10px]
                  max-h-[10px]
                  min-h-[10px]
                  max-w-[10px]
                  rounded-full
                  mt-[2px]
                  transition-all
                  duration-300
                  flex
                  justify-center
                  items-center
                "
                @mouseover="languageOpened = true"
                :style="`background:${textColor}`"
                :class="{ 'lang-dot-animate': languageOpened }"
              >
                <i
                  class="fa fa-times transition-all duration-300 text-xs"
                  :style="`color:${closeIcoColor}`"
                  :class="languageOpened ? 'opacity-100' : 'opacity-0'"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-[1px] h-[100px] md:mx-10 mx-6 sm:mx-3"
        :style="`background:${borderColor}`"
      ></div>

      <HamburgerIcon
        :color="textColor"
        :menuOpened="menuOpened"
        @openMenu="menuOpened = !menuOpened"
        :languagesOpened="languageOpened"
      />
    </div>
  </div>
</template>

<script>
import HamburgerIcon from "../../assets/icons/HamburgerIcon.vue";
import MenuCollapse from "/src/components/UI/MenuCollapse.vue";
export default {
  inject: ["content"],
  data() {
    return {
      menuOpened: false,
      languageOpened: false,
    };
  },
  methods: {
    updateLanguage() {
      if (this.language == "en") {
        localStorage.setItem("lang", "ku");
      } else {
        localStorage.setItem("lang", "en");
      }
      this.$router.go();
    },
  },

  computed: {
    lastRoute() {
      return this.$route.path.split("/")[1];
    },
    language() {
      return localStorage.getItem("lang");
    },
    textColor() {
      let color = "#000";
      if (this.lastRoute == "" && !this.menuOpened) color = "#fff";
      else if (this.lastRoute == "" && !this.menuOpened) color = "#000";
      else color = "#000";
      return color;
    },
    closeIcoColor() {
      let color = "#fff";
      if (this.lastRoute == "" && !this.menuOpened) color = "#000";
      else if (this.lastRoute == "" && !this.menuOpened) color = "#fff";
      else color = "#fff";
      return color;
    },
    borderColor() {
      let color = "#0001";
      if (this.lastRoute == "" && !this.menuOpened) color = "#fff3";
      else if (this.lastRoute == "" && !this.menuOpened) color = "#0001";
      else color = "#0001";
      return color;
    },
  },
  watch: {
    menuOpened() {
      if (this.menuOpened) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    },
  },
  components: {
    HamburgerIcon,
    MenuCollapse,
  },
};
</script>